// extracted by mini-css-extract-plugin
export default {"input":"PersonalDataSection_input__VCRFI"};